export default "__VITE_ASSET__069e6c91__"